import { createUseStyles } from 'react-jss'

import { MQ, COLOR, Z_INDEX } from 'utils/constants'

export const useStyles = createUseStyles({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    color: COLOR.DARK_GREEN,
    [MQ.DESKTOP]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      textAlign: 'left',
      position: 'relative',
    },
  },
  textBlock: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: [0, '6%', 65],
    [MQ.TABLET]: {
      padding: [15, '6%', 90],
    },
    [MQ.DESKTOP]: {
      alignItems: 'flex-start',
      minHeight: 470,
      padding: [0, 50, 65, '9.6%'],
    },
    [MQ.DESKTOP_XL]: {
      minHeight: 600,
    },
    [MQ.DESKTOP_XXL]: {
      minHeight: 800,
    },
  },
  title: {
    padding: [30, 0, 0],
  },
  subtitle: {
    padding: [15, 0, 31],
    lineHeight: 1.6,
    maxWidth: 430,
    [MQ.TABLET]: {
      padding: [25, 0, 40],
    },
    [MQ.DESKTOP]: {
      padding: [20, 0, 55],
    },
  },
  viewMore: {
    border: 'none',
    outline: 'none',
    backgroundColor: COLOR.ORANGE,
    textDecoration: 'none',
    color: COLOR.WHITE,
    padding: [0, 20],
    position: 'relative',
    borderRadius: 8,
    cursor: 'pointer',
    [MQ.TABLET]: {
      padding: [5, 35],
    },
    [MQ.DESKTOP]: {
      padding: [0, 30],
    },
  },
  videoWrapper: {
    minHeight: 315,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: COLOR.BLACK,
    [MQ.TABLET]: {
      minHeight: 450,
      height: '53.89vw',
    },
    [MQ.DESKTOP]: {
      width: '50%',
      position: 'absolute',
      top: -210,
      right: 0,
      minHeight: 680,
      height: 'calc(100% + 210px)',
    },
    [MQ.DESKTOP_LARGE]: {
      width: '54%',
    },
  },
  video: {
    position: 'relative',
    width: '100%',
    height: '0',
    paddingBottom: 'max(56.25%, 315px)',
    backgroundColor: COLOR.BLACK,
    [MQ.TABLET]: {
      paddingBottom: 'max(56.25%, 450px)',
    },
    [MQ.DESKTOP]: {
      zIndex: Z_INDEX.DESKTOP_VIDEO,
      paddingBottom: '100%',
      height: '100%',
    },
    '& iframe': {
      opacity: 0,
      backgroundColor: COLOR.BLACK,
      position: 'absolute',
      top: '0',
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      minWidth: 560,
      height: '100%',
      [MQ.TABLET]: {
        minWidth: 924,
      },
      [MQ.DESKTOP]: {
        minWidth: 1250,
        minHeight: 680,
      },
    },
  },

  openModal: {
    position: 'absolute',
    zIndex: Z_INDEX.CONTENT,
    width: 90,
    height: 90,
    backgroundColor: COLOR.WHITE,
    opacity: 0.5,
    borderRadius: '50%',
    outline: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    [MQ.DESKTOP]: {
      width: 125,
      height: 125,
      zIndex: Z_INDEX.DESKTOP_BUTTON,
    },
  },
  triangle: {
    width: '0',
    height: '0',
    borderTop: '20px solid transparent',
    borderBottom: '20px solid transparent',
    borderLeft: '35px solid white',
    opacity: 1,
    zIndex: Z_INDEX.CONTENT,
    position: 'absolute',
    marginLeft: 5,
    [MQ.DESKTOP]: {
      zIndex: Z_INDEX.DESKTOP_BUTTON,
      borderTop: '30px solid transparent',
      borderBottom: '30px solid transparent',
      borderLeft: '50px solid white',
      marginLeft: 15,
    },
  },

  modal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.6)',
    zIndex: 10000,
  },
  modalFlex: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [MQ.DESKTOP]: {
      marginTop: '10vh',
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
    '& iframe': {
      width: '100%',
      height: 'calc( 100vw * .5625 )',
      order: 5,
      [MQ.DESKTOP]: {
        width: '80%',
        height: ' calc( (100vw * .5625 ) * .8)',
        order: 1,
      },
    },
  },

  modalFlexMobileFlipped: {
    '& iframe': {
      height: '60vh',
    },
  },
  modalFlexTall: {
    '& iframe': {
      [MQ.DESKTOP]: {
        width: 'calc( 65vh * 1.777777777 ) ',
        height: '65vh',
      },
    },
  },

  closeModal: {
    backgroundColor: 'rgba(0,0,0,0)',
    border: 'none',
    cursor: 'pointer',
    marginTop: 50,
    order: 1,
    outline: 'none',
    width: 100,
    height: 100,
    [MQ.DESKTOP]: {
      marginTop: 0,
      marginLeft: 25,
    },
  },
  firstLine: {
    position: 'relative',
    width: 100,
    height: 100,
    '&:before': {
      position: 'absolute',
      content: '""',
      height: 35,
      width: 2,
      backgroundColor: COLOR.YELLOW,
      transform: 'rotate(45deg)',
      [MQ.DESKTOP]: {
        height: 75,
      },
    },
    '&:after': {
      position: 'absolute',
      content: '""',
      height: 35,
      width: 2,
      backgroundColor: COLOR.YELLOW,
      transform: 'rotate(-45deg)',
      [MQ.DESKTOP]: {
        height: 75,
      },
    },
  },
  shortButton: {
    width: 50,
    height: 50,
  },
  hidden: {
    position: 'absolute',
    left: '-200vw',
  },
  loaded: {
    '& iframe': {
      transition: 'opacity 1.5s',
      opacity: 1,
    },
  },
})
